import ninjaApi from 'store/redux/apis/ninja.api';

export const metaApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['NetworkAccount'],
  endpoints: (build) => ({
    /* Login facebook Account */
    connectMeta: build.mutation({
      query: (data) => ({
        url: '/apps/meta/auth/connect',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['NetworkAccount'],
    }),
  }),
});

export const { useConnectMetaMutation } = metaApi;
